import * as Types from '@typings/graphql-models';

const isOneTimePrice = (price: Pick<Types.Price, 'usageType'>): boolean => (price.usageType === Types.StripePriceUsageType.OneTime);
export default isOneTimePrice;
